import axios from "axios";
import { txMsg } from "./i18n";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((c) => { if (!c.headers["X-MIVO-Lang"]) c.headers["X-MIVO-Lang"] = localStorage.getItem("mivo_lang") || "en"; return c; });

let refreshing = null;
const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
api.interceptors.response.use(null, async (err) => {
  const cfg = err.config || {};
  const st = err.response?.status;
  if (st === 401 && !cfg._retried && !NO_REFRESH.some((p) => (cfg.url || "").startsWith(p))) {
    cfg._retried = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => setTimeout(() => { refreshing = null; }, 0));
    try { await refreshing; return api(cfg); } catch {
      if (window.__mivoAuthed) { window.__mivoAuthed = false; window.dispatchEvent(new Event("mivo:session-expired")); }
      err.response.data = { ...(err.response.data || {}), detail: "Your session has expired. Please sign in again." };
      return Promise.reject(err);
    }
  }
  const method = (cfg.method || "get").toLowerCase();
  if (method === "get" && (!err.response || st >= 500) && (cfg._tries || 0) < 2) {
    cfg._tries = (cfg._tries || 0) + 1;
    await sleep(600 * cfg._tries);
    return api(cfg);
  }
  return Promise.reject(err);
});
api.defaults.timeout = 30000;

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export function errMsg(e) {
  return txMsg(rawErr(e));
}

function rawErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
